export const ThankyousignupStyle = (theme) => ({
	paper: {
		textAlign: "-webkit-center",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${
			theme.spacing.unit * 3
		}px`
	},
	avatar: {
		margin: theme.spacing.unit,
		backgroundColor: "#8bc34a",
		width: 60,
		height: 60
	},
	root: {
		display: "flex",
		width: "100%",
		flexWrap: "wrap"
	}
})
